import { Service, service, inject } from "./di";
import { LocationService } from "./LocationService";
import {SeoDataService} from "./SeoDataService";

@service
export default class LocationBrowserService extends Service {
	@inject locationService: LocationService;
	@inject dataService: SeoDataService;

	state: string;

	getStates(countryUrl: string, productName: string) {
		const states = countryUrl === "en-us" ? this.dataService.getTopUsStates() : this.dataService.getTopCaProvinces();
		return states.map((state: any) => {
				const s = state.stateCode.toLowerCase();
				this.state = s;

				const url = this.isLocationsBrowser() ?
					`/${this.locationService.locale}/browser/${s}` :
					`/${this.locationService.locale}/products/${productName}/browser/${s}`;

				return {
					url,
					name: state.stateName,
				};
			});
	}

	getCities(state: string, countryUrl: string, productName: string) {
		const cities = countryUrl === "en-us" ? this.dataService.getTopUsCities() : this.dataService.getTopCaCities();
		return cities
			.filter((city: any) => city.state === state.toUpperCase())
			.map((city: any) => ({
				url : this.getProductUrl({
					countryUrl,
					cityState: city.state,
					cityName: city.name,
					productName
				}),
				name: city.name,
			}));
	}

	getProductUrl(config: any) {
		const {countryUrl, cityName, productName, cityState} = config;
		const country = countryUrl === "en-us" ? "us" : "ca";
		if (this.isLocationsBrowser()) {
			return `/${this.locationService.locale}/browser/${cityState}/${cityName}`.toLowerCase();
		}

		const lang = this.locationService.locale.split("-")[0];
		const locale = `${lang}-${lang === "fr" ? "ca" : country}`;
		return `/${locale}/search/${this.getInCityUrl(cityState, cityName)}/${productName}`;
	}

	getInCityUrl = (state: string, city: string) => `${this.getCityUrl(city)}-${state.toLowerCase()}`;
	getCityUrl = (city: string): string =>
		city
			.split(" ")
			.map((c: string) => c.toLowerCase())
			.join("-")

	isLocationsBrowser = () => !window.location.pathname.includes("products");
}
